import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';


@Component({
  selector: 'app-inventory-manager',
  templateUrl: './inventory-manager.component.html',
  styleUrls: ['./inventory-manager.component.css']
})
export class InventoryManagerComponent implements OnInit {
  dataSource;
  displayedColumns = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    // other options...
    dateFormat: 'dd/mm/yyyy',
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any = {};
  editId: any;
  brands: any = [];
  columnNames: { id: string; value: string; }[];
  module_accessFixed: any;
  addAccessFixed: boolean = false;
  editAccessFixed: boolean = false;
  viewAccessFixed: boolean = false;
  deleteAccessFixed: boolean = false;

  module_accessProduct: any;
  addAccessProduct: boolean = false;
  editAccessProduct: boolean = false;
  viewAccessProduct: boolean = false;
  deleteAccessProduct: boolean = false;

  module_accessUsables: any;
  addAccessUsables: boolean = false;
  editAccessUsables: boolean = false;
  viewAccessUsables: boolean = false;
  deleteAccessUsables: boolean = false;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService,
    private _arout: ActivatedRoute

  ) {
  }


  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_accessFixed = JSON.parse(this.currentUser['module_access'])
        this.module_accessProduct = JSON.parse(this.currentUser['module_access'])
        this.module_accessUsables = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_accessFixed = ''
        this.module_accessProduct = ''
        this.module_accessUsables = ''
      }
    } else {
      this.module_accessFixed = ''
      this.module_accessProduct = ''
      this.module_accessUsables = ''
    }

    this.model.brand_name = ''
    this.loginservice.getBrands('', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] === 'success') {
            this.brands = data['data'];
            this.model.brand = 'All';
          } else {
            this.brands = [];
          }
        }, error => { alert('Network Error getBrands API'); });

    this._arout.params.subscribe(p => {
      if (p.inventory_item_id === '3') {
        this.columnNames = [];
        this.columnNames = [{
          id: 'sno',
          value: 'No.',

        }, {
          id: 'inventory_item_name',
          value: 'Inventory Type',
        }, {
          id: 'short_desc',
          value: 'Inventory Name',
        }, {
          id: 'brand',
          value: 'Brand',
        }, {
          id: 'quantity_on_hand',
          value: 'Quantity On Purchase',
        }, {
          id: 'pur_date',
          value: 'Purchased Date',
        }, {
          id: 'actions',
          value: 'Action',
        }
        ];
      } else {
        this.columnNames = [];
        this.columnNames = [{
          id: 'sno',
          value: 'No.',

        }, {
          id: 'inventory_item_name',
          value: 'Inventory Type',
        }, {
          id: 'short_desc',
          value: 'Inventory Name',
        }, {
          id: 'brand',
          value: 'Brand',
        }, {
          id: 'product_type1',
          value: 'Product Type',
        },
        // {
        //   id: 'unit_of_measurement',
        //   value: 'UOM',
        // },
        {
          id: 'quantity_on_hand',
          value: 'Quantity On Purchase',
        }
          // , {
          //   id: 'isEmpty1',
          //   value: 'Availability',
          // }, {
          //   id: 'customer_usage',
          //   value: 'Balance',
          // }
          , {
          id: 'actions',
          value: 'Action',
        }
        ];
      }
      if (p.inventory_item_id) {
        this.editId = p.inventory_item_id;
        this.getInventorymanager(p.inventory_item_id);
      } else {
        this.editId = '';
        this.getInventorymanager('');
      }

      if (this.editId === '1') {
        var checkAccess = this.checkModuleAccesFixed('14');
        if (!checkAccess) {
          alert("You don't have access for this module. Please contact admin.")
          this.router.navigate(['/Selectport']);
          return;
        }
      } else if (this.editId === '2') {
        var checkAccess = this.checkModuleAccesProduct('15');
        if (!checkAccess) {
          alert("You don't have access for this module. Please contact admin.")
          this.router.navigate(['/Selectport']);
          return;
        }
      } else {
        var checkAccess = this.checkModuleAccesUsables('16');
        if (!checkAccess) {
          alert("You don't have access for this module. Please contact admin.")
          this.router.navigate(['/Selectport']);
          return;
        }
      }

      this.displayedColumns = this.columnNames.map(x => x.id);
    }, error => { alert('Network Error params API'); });


  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addvendor(model) {
    this._arout.params.subscribe(p => {
      if (p.inventory_item_id == 1) {
        this.router.navigate(['add-inventory-manager/product/' + p.inventory_item_id]);
      } else if (p.inventory_item_id == 2) {
        this.router.navigate(['add-product/product/' + p.inventory_item_id]);
      } else {
        // this.router.navigate(['add-inventory-manager/']);
        this.router.navigate(['add-usables/usables/' + p.inventory_item_id]);
      }
    }, error => { alert('Network Error params API'); });
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => this.searching = true)
      .switchMap(term =>
        this.Autosuggest.getContractorNames(term, 'child')
          .map(response => <string[]>response['c_names'])
          .do(() => this.searchFailed = false)
          .catch(() => {
            this.searchFailed = true;
            return Observable.of([]);
          }))
      .do(() => this.searching = false)
      .merge(this.hideSearchingWhenUnsubscribed)
  formatter = (x: { orgName: string }) => x.orgName;

  serchTypeHead(id) {
    // alert(id);
    setTimeout(() => {
      if (this.model.orgName != undefined) {
        if (this.userType == 0) {
          this.loginservice.setLocalSession(this.model, 'currentOrg');
          this.currentOrg = this.model;
          this.getInventorymanager('');
        }
      }



    }, 500)

  }

  clearAll() {
    // this.model = { fundingSourceId: 0, classification: 0 };
    // this.model = "";
    this.certificate = {};
  }


  getInventorymanager(inventory_manager_id) {
    this.loginservice.getInventorymanager(inventory_manager_id, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.dataresult = data['comp_details'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['comp_details'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error getInventorymanager API');
          this.showLoader = false;
        });
  }


  // Angular component code
  handleClick(columnId: string, element: any) {
    switch (columnId) {
      // case 'edit':
      //   this.edit(element.vendor_id);
      //   break;
      // case 'view':
      //   this.view(element.vendor_id);
      //   break;
      case 'delete':
        this.delete(element.vendor_id);
        break;
      default:
        break;
    }
  }

  delete(inventory_item_id: number) {
    // Handle delete action
    // alert('delete');
    // alert(inventory_item_id);
    if (confirm('Deleting of this inventory item is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridData(inventory_item_id, 'id', 'inventory_manager', 'status').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Error in delete');
            this.showLoader = false;
          });
      }
    }
  }

  cancelAddbrand() {
    this.ngOnInit()
  }

  deleteBrand(brand) {
    var result = confirm("Want to delete?");
    if (result) {
      this.loginservice.deleteBrand(brand, this.currentUser).subscribe(data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        } else {
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        }
      },
        error => {
          alert('Network Error deleteBrand API');
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        });
    }
  }

  Addbrand(brand) {
    this.loginservice.Addbrand(brand, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
        } else {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
        }
      }, error => { alert('Network Error Addbrand API'); });

  }


  checkModuleAccesFixed(module_id: string): boolean {
    if (!this.module_accessFixed) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_accessFixed)
      ? this.module_accessFixed
      : JSON.parse(this.module_accessFixed);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccessFixed = !!mod.add;
      this.editAccessFixed = !!mod.edit;
      this.viewAccessFixed = !!mod.view;
      this.deleteAccessFixed = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccessFixed = false;
      this.editAccessFixed = false;
      this.viewAccessFixed = false;
      this.deleteAccessFixed = false;
      return false;
    }
  }

  checkModuleAccesProduct(module_id: string): boolean {
    if (!this.module_accessProduct) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_accessProduct)
      ? this.module_accessProduct
      : JSON.parse(this.module_accessProduct);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccessProduct = !!mod.add;
      this.editAccessProduct = !!mod.edit;
      this.viewAccessProduct = !!mod.view;
      this.deleteAccessProduct = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccessProduct = false;
      this.editAccessProduct = false;
      this.viewAccessProduct = false;
      this.deleteAccessProduct = false;
      return false;
    }
  }

  checkModuleAccesUsables(module_id: string): boolean {
    if (!this.module_accessUsables) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_accessUsables)
      ? this.module_accessUsables
      : JSON.parse(this.module_accessUsables);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccessUsables = !!mod.add;
      this.editAccessUsables = !!mod.edit;
      this.viewAccessUsables = !!mod.view;
      this.deleteAccessUsables = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccessUsables = false;
      this.editAccessUsables = false;
      this.viewAccessUsables = false;
      this.deleteAccessUsables = false;
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/inventory-manager/inventory-manager.component.ts